import { MutationTree } from 'vuex';

import { subscribableStore } from './common';
import { ActivitiesGpsState } from './types';

const mutations: MutationTree<ActivitiesGpsState> = {
  ...subscribableStore.mutations,
};

export default mutations;
